import React, { useCallback } from 'react';
import {Footer, HeaderNavi, Pagination} from '@components';
import { useNavigate, useSearchParams  } from 'react-router-dom';
import { FormProvider } from 'react-hook-form';
import { Input, Select } from '@components/form';
import {useLectureList} from '@hooks';
import { getOptions, getCodeByName  } from '@utils/CommonCodes';


const LectureList = () => {
    const [searchParams] = useSearchParams();
    const urlEduType = searchParams.get('eduType') || 'B';

    const navigate = useNavigate();
    const { 
        methods, lectureList, categoryList,
        onSubmit, handlePageChange,
        pageIndex 
    } = useLectureList();

    const { handleSubmit, setValue, reset } = methods;

    const handleMenuClick = useCallback(
        (code) => {
          setValue('eduType', code, { shouldValidate: false });
          onSubmit({ ...methods.getValues(), eduType: code });
        },
        [methods, onSubmit, setValue],
      );

    const handleReset = () => {
        reset({ eduCategoryId: '', eduType: 'B', searchWrd: '' });
        onSubmit({ eduCategoryId: '', eduType: 'B', searchWrd: '' });
    };

    const data = lectureList ?? {};  

  return (
    <main id="main" className="mainpage">
            <>
            <div>
            <div className="section main-contact">

                <HeaderNavi/>
                
                <div className="sub-container">
                    <div className="sub-layout">
                    <div className="left-menu">
                        <h2>교육신청</h2>
                        <ul>
                            {getOptions("EDU_TYPE")
                                .filter(opt => ["B", "C", "D", "E"].includes(opt.comdCode))
                                .map(({ comdCode, comdName }) => (
                                <li
                                    key={comdCode}
                                    className={urlEduType === comdCode ? 'sub-menu-on' : ''}
                                    onClick={() => handleMenuClick(comdCode)}
                                >
                                    {comdName}
                                </li>
                            ))}
                        </ul>
                    </div>
                        <div className="sub-contact">
                            <h3 className="border-bt">{getCodeByName("EDU_TYPE", urlEduType)}</h3>
                            <FormProvider {...methods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="input-box">
                                <div className="input-box-inner">
                                    <div className="fom-inp">
                                    <Select
                                        name="eduCategoryId"
                                        options={categoryList?.result}
                                        defaultOption="전체"
                                        valueKey="eduCategoryId"
                                        labelKey="eduCategoryNm"
                                        className="inp-sel"
                                    />  
                                    </div>
                                    {/* <div className="fom-item">
                                        <select
                                            name="subCode"
                                            className="inp-sel"
                                        >
                                            <option value="">전체</option>
                                            <option value="s001">제조업</option>
                                            <option value="s002">건설업</option>
                                            <option value="s003">서비스업</option>
                                        </select>
                                    </div> */}
                                    <div className="fom-inp" style={{display:"flex"}}>
                                        <Input
                                            name="searchWrd"
                                            placeholder="교육과정명을 검색하세요."
                                            className="inp-sel2"
                                        />
                                        <button type="submit" className="form-icon btn_seach" />
                                    </div>
                                </div>
                                <span>
                                    <button type="button" className="btn_reset" onClick={handleReset}>
                                        초기화
                                    </button>
                                </span>
                            </div>
                            </form>
                            </FormProvider>
									
                            <div>
                                {data.resultList && data.resultList.length > 0 ? (
                                    <ul className="sub_banner mb50">
                                        {data.resultList.map((item) => (
                                            <li key={item.lectureId}>
                                                <span className="no01">{item.eduCategoryNm}</span>
                                                <b>{item.lectureNm}</b>
                                                <dl>
                                                    <dt>신청기간</dt>
                                                    <dd>{item.applyStartDt} ~ {item.applyEndDt}</dd>
                                                </dl>
                                                <dl>
                                                    <dt>교육일시</dt>
                                                    <dd>{item.firstDt} {item.lastDt && ` , ${item.lastDt}`} ({item.eduHours}h)</dd>
                                                </dl>
                                                <dl>
                                                    <dt>정원</dt>
                                                    <dd>{item.curStudentCnt} / {item.eduStdntLimit}</dd>
                                                </dl>
                                                <div className="text-cent">
                                                    {item.lectureStatus === 'A' ?  (
                                                        <button
                                                            className="btn btn_red mt30"
                                                            onClick={() => navigate(`/lecture/detail/${item.lectureId}`)}
                                                        >
                                                            교육신청
                                                        </button>
                                                    ) : (
                                                        <button className="btn btn_bl mt30" disabled>
                                                            교육마감
                                                        </button>
                                                    )}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                        <span style={{ marginLeft: '10px' }}>검색 결과가 없습니다.</span>
                                )}

                                {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                                    <Pagination
                                        totalPages={Math.ceil(
                                            data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                                        )}
                                        currentPage={pageIndex}
                                        onPageChange={handlePageChange}
                                        pageRangeDisplayed={5} 
                                    />
                                )}
                            </div>
                        </div>	
                    </div>	
                </div>
                <Footer />
            </div>
            </div>
        </>
   </main>


  );
};


export default LectureList;
